import axiosInstance from "./AxiosInstance";

export function getSelectOptionList(
  endPoint
) {
  return axiosInstance.get(
    `api/transport/${endPoint}`
  );
}

export function getDriverListSearchApi(query) {
  return axiosInstance.get(
    `api/transport/search-driver`, { params: { query } }
  );
}

export function getEmployeeListSearchApi(query) {
  return axiosInstance.get(
    `api/transport/search-employee`, { params: { query } }
  );
}
export function getBusListSearchApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/search-bus?${fparam}`
  );  
}
export function getShiftListSearchApi(query) {
  return axiosInstance.get(
    `api/transport/search-shift`, { params: { query } }
  );
}
export function getStopListSearchApi(query) {
  return axiosInstance.get(
    `api/transport/search-stop`, { params: { query } }
  );
}
export function getRouteStopListSearchApi(query) {
  return axiosInstance.get(
    `api/transport/search-route-stop`, { params: { query } }
  );
}
export function getRouteListSearchApi(query) {
  return axiosInstance.get(
    `api/transport/search-route`, { params: { query } }
  );
} 
